
import React from 'react';
import FooterLogo from './FooterLogo';
import FooterCTA from './FooterCTA';

const FooterTop = () => {
  return (
    <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-12">
      <FooterLogo />
      <FooterCTA />
    </div>
  );
};

export default FooterTop;
